const MEDIA_ITEMS = [
  {
    title: 'APP使用教程：从下载到追剧',
    desc: '手把手教你完成91影视看片APP的下载安装与基础操作',
    duration: '03:25',
    image: 'https://readdy.ai/api/search-image?query=A%20smartphone%20screen%20showing%20a%20video%20tutorial%20interface%20with%20Chinese%20text%20overlay%2C%20app%20installation%20guide%20visual%2C%20warm%20soft%20lighting%2C%20clean%20desk%20setup%2C%20modern%20tech%20tutorial%20style%2C%20friendly%20learning%20atmosphere&width=800&height=450&seq=media-tutorial-2026&orientation=landscape',
  },
  {
    title: '新功能速览：智能推荐系统',
    desc: '了解最新上线的个性化推荐功能，发现更多符合口味的影视内容',
    duration: '02:18',
    image: 'https://readdy.ai/api/search-image?query=A%20clean%20modern%20app%20interface%20display%20with%20recommendation%20cards%20and%20movie%20posters%2C%20smart%20AI%20recommendation%20visual%2C%20warm%20tech%20aesthetic%2C%20minimal%20design%2C%20soft%20gradient%20background&width=800&height=450&seq=media-feature-2026&orientation=landscape',
  },
  {
    title: '投屏功能演示：手机连电视',
    desc: '教你如何将手机画面一键投射到智能电视，享受大屏观影乐趣',
    duration: '04:12',
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20living%20room%20with%20a%20large%20smart%20TV%20and%20a%20smartphone%20side%20by%20side%2C%20screen%20mirroring%20concept%2C%20warm%20cozy%20home%20cinema%20setup%2C%20soft%20ambient%20lighting%2C%20comfortable%20sofa&width=800&height=450&seq=media-casting-2026&orientation=landscape',
  },
  {
    title: '离线下载攻略：无网也能看',
    desc: '详细讲解批量离线缓存的操作流程，让你的通勤路上不再无聊',
    duration: '02:45',
    image: 'https://readdy.ai/api/search-image?query=A%20smartphone%20displaying%20download%20progress%20screen%20with%20video%20thumbnails%2C%20offline%20viewing%20concept%2C%20warm%20subway%20or%20commute%20background%2C%20modern%20mobile%20lifestyle%2C%20soft%20natural%20lighting&width=800&height=450&seq=media-offline-2026&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full mb-4 whitespace-nowrap">
            <i className="ri-play-circle-line mr-1"></i>使用教程
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            视频教程与指南
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            通过实操演示快速掌握91影视看片APP的各项功能
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {MEDIA_ITEMS.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 cursor-pointer"
            >
              <div className="relative h-44 md:h-48 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/35 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-white/90 text-primary-500 group-hover:bg-primary-500 group-hover:text-white transition-all">
                    <i className="ri-play-fill text-xl md:text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3">
                  <span className="px-2.5 py-1 bg-black/60 backdrop-blur-sm text-white text-xs font-medium rounded-full whitespace-nowrap">
                    {item.duration}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}